import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable()
export class KidsGuardService {
  protected readonly onDestroy$: Subject<void> = new Subject();

  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return new Observable<boolean | UrlTree>((observer) => {
      this.store.pipe(select(fromAppRoot.selectCustomer), takeUntil(this.onDestroy$)).subscribe((customer) => {
        if (!customer || !customer.accounts) {
          return;
        }

        const investmentAccount = customer.accounts.filter((item) => item.kind === '3b');
        if (customer.app_location === 'ch' && investmentAccount.length) {
          if (investmentAccount[0].step_status < 4 && route.routeConfig.path.includes('register')) {
            observer.next(this.router.parseUrl('/kids/accounts'));
          }
          observer.next(true);
        } else {
          observer.next(this.router.parseUrl('/'));
        }
        this.onDestroy$.next();
        this.onDestroy$.complete();
      });
    });
  }
}

export const KidsGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  return inject(KidsGuardService).canActivate(route);
};
